import { PayLayout } from '@components/templates';
import { lazyWithReload } from '@shared/react/lazyWithReload';
import { Route } from 'react-router-dom';

import {
  recurringPaymentPath,
  recurringPaymentProcessingPath,
  recurringPaymentSuccessPath,
  recurringPaymentUpdatePath,
} from './urls';

const RecurringPayment = lazyWithReload(() =>
  import('./pages/RecurringPayment').then((m) => ({
    default: m.RecurringPayment,
  }))
);

const RecurringPaymentSuccess = lazyWithReload(() =>
  import('./pages/RecurringPaymentSuccess').then((m) => ({
    default: m.RecurringPaymentSuccess,
  }))
);

const RecurringPaymentProcessing = lazyWithReload(() =>
  import('./pages/RecurringPaymentProcessing').then((m) => ({
    default: m.Container,
  }))
);

const RecurringPaymentUpdate = lazyWithReload(() =>
  import('./pages/RecurringPaymentUpdate').then((m) => ({
    default: m.RecurringPaymentUpdate,
  }))
);

export const RecurringPaymentRoutes = (
  <>
    <Route element={<PayLayout />}>
      <Route path={recurringPaymentUpdatePath} element={<RecurringPaymentUpdate />} />
      <Route path={recurringPaymentSuccessPath} element={<RecurringPaymentSuccess />} />
      <Route path={recurringPaymentProcessingPath} element={<RecurringPaymentProcessing />} />
      <Route path={recurringPaymentPath} element={<RecurringPayment />} />
    </Route>
  </>
);

export default RecurringPaymentRoutes;
